import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './accolades-carousel-item.component.scss';
var AccoladesCarouselItem = /** @class */ (function (_super) {
    tslib_1.__extends(AccoladesCarouselItem, _super);
    function AccoladesCarouselItem(element) {
        return _super.call(this, element) || this;
    }
    AccoladesCarouselItem.prototype.init = function () { };
    ;
    AccoladesCarouselItem.prototype.bindEvents = function () { };
    ;
    return AccoladesCarouselItem;
}(Base));
export { AccoladesCarouselItem };



//////////////////
// WEBPACK FOOTER
// ./components/accolades-carousel-item/accolades-carousel-item.component.ts
// module id = 71
// module chunks = 0